export default {
  'pages.rc.80620': 'Add calendar exist same name',
  'pages.rc.1033': 'Username or password error, please re-enter',
  'pages.rc.1029': 'Username or password error, please re-enter'
};
